import { render } from "./heroDefaultBlock.vue?vue&type=template&id=821180a6&ts=true"
import script from "./heroDefaultBlock.vue?vue&type=script&lang=ts"
export * from "./heroDefaultBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__